import * as RUISelect from '@radix-ui/react-select';
import * as Separator from '@radix-ui/react-separator';
import styles from './select.module.scss';
import classNames from 'classnames';
import {useIntl} from 'react-intl';

type Item = {
  label: string;
    value: string;
    disabled?: boolean;
}

interface SelectProps {
  items: Item[];
  value?: string;
  defaultValue?: string;
  onChange?: (value: string) => void;
  triggerClassName?: string;
}

const Select = ({items, triggerClassName, onChange, ...rest}: SelectProps) => {
  const intl = useIntl();
  return (
    <RUISelect.Root onValueChange={onChange} {...rest}>
      <RUISelect.Trigger className={classNames(styles.trigger, triggerClassName)}>
        <RUISelect.Value placeholder={intl.formatMessage({id: 'sharedSelect'})} />
        <RUISelect.Icon className={styles.selectIcon}>
          <i className='fas fa-chevron-down' />
        </RUISelect.Icon>
      </RUISelect.Trigger>

      <RUISelect.Content position='popper' sideOffset={8} className={styles.selectContent}>
        <RUISelect.Viewport>
          {items.map((item, index, array) => (
            <>
              <RUISelect.Item
                disabled={item.disabled}
                value={item.value}
                className={styles.selectItem}
              >
                <RUISelect.ItemText>{item.label}</RUISelect.ItemText>
              </RUISelect.Item>
              {index < array.length - 1 && <Separator.Root className={styles.separator} />}
            </>
          ))}
        </RUISelect.Viewport>
      </RUISelect.Content>
    </RUISelect.Root>
  );
};

export default Select;
